export default str => str !== "";
